var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"breadcrumb-container",attrs:{"separator":"/"}},_vm._l((_vm.list),function(item){return _c('el-breadcrumb-item',{key:item.path},[_c('span',{class:{
        'is-active': _vm.$route.meta.title == item.meta.title,
      }},[_vm._v(" "+_vm._s(item.meta.title)+" ")])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }